import { fork, take, put, select } from 'redux-saga/effects';
import { get, set, LS_WISH_LIST } from '@ts/utils/ls';
import actions from '../actions';
import selectors from '../selectors';

function* watchChange() {
    while (true) {
        yield take([
            actions.wishList.ActionTypes.CHANGE,
            actions.wishList.ActionTypes.ADD,
            actions.wishList.ActionTypes.REMOVE,
        ]);

        const items = yield select(selectors.wishList.makeSelectAll());
        set(LS_WISH_LIST, items);
    }
}

export default function* wishListSaga() {
    const items = get(LS_WISH_LIST);

    if (Array.isArray(items)) {
        yield put(actions.wishList.change(items.map(Number).filter(Boolean)));
    }

    yield fork(watchChange);
}
